import { createLivePreviewRequestHandler } from "src/utils/livePreviewHandler";

/**
 * Live preview request handler for `eat-and-play-menus` (collection uses drafts).
 */
export const eatAndPlayLivePreviewRequestHandler = createLivePreviewRequestHandler(
  ({ serverURL, apiPath, docId }) =>
    `${serverURL}${apiPath}/eat-and-play-menus/${docId}?depth=0&draft=true`
);
